import axios from 'axios'
import router from '@/router/index'
import { Notification } from 'element-ui'
import { axiosFactory, errorHandler } from '@/configs/axios'

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    errorHandler(error)
    return Promise.reject(error)
  }
)

const state = () => ({
  userId: null,
  access_token: null,
  refresh_token: null,
  user_name: '',
  isSuperuser: null,
})

const getters = {
  userId(state) {
    return state.userId
  },
  token(state) {
    return state.access_token
  },
  refreshToken(state) {
    return state.refresh_token
  },
  user_name(state) {
    return state.user_name
  },
  isSuperuser(state) {
    return state.isSuperuser
  },
  force_reset_password(state) {
    return state.force_reset_password
  },
  isMobileVerified(state) {
    return state.isMobileVerified
  },
  mobile(state) {
    return state.mobile
  },
}
const mutations = {
  SET_USER(state, payload) {
    // console.log(payload);
    state.userId = payload.userId
    state.user_name = payload.user_name
  },
  SET_TOKEN(state, payload) {
    state.access_token = payload.access_token
    state.refresh_token = payload.refresh_token
  },
  RESET_PASS(state, payload) {
    state.force_reset_password = payload
  },
  SET_MOBILE(state, payload) {
    state.mobile = payload
  },
  IS_MOBILE_VERIFIED(state, payload) {
    state.isMobileVerified = payload
  },
}
const actions = {
  login(context, payload) {
    return context.dispatch('auth', {
      ...payload,
      mode: 'login',
    })
  },
  signup(context, payload) {
    return context.dispatch('auth', {
      ...payload,
      mode: 'signup',
    })
  },
  auth(context, payload) {
    let url = 'users/token/'
    return axiosFactory()
      .default.post(url, {
        username: payload.username,
        password: payload.password,
      })
      .then((res) => {
        let data = res.data
        if (data) {
          localStorage.setItem('access_token', data.access)
          localStorage.setItem('refresh_token', data.refresh)
          context.commit('SET_TOKEN', {
            access_token: data.access,
            refresh_token: data.refresh,
          })
          // context.dispatch('getUser').then((res) => {
          // if (res) {
          let loginMsg = ''
          if (context.getters.locale == 'fa') {
            loginMsg = 'با موفقیت وارد سیستم شدید'
          } else {
            loginMsg = 'Successfully logged in'
          }
          Notification.success({
            title: loginMsg,
            duration: 4000,
            customClass: 'succ_msg',
          })
          router.push('/' + context.getters.locale + '/dashboard')
          // }
          // })
        } else {
          Notification.error({
            title: res,
            duration: 4000,
            customClass: 'error_msg',
          })
        }
      })
      .catch((error) => {
        errorHandler(error)
        return false
      })
  },
  getUser(context) {
    return axiosFactory()
      .auth.get('users/office-staffs/')
      .then((res) => {
        let userData = res.data.user
        if (userData.type == 1) {
          let fullName = userData.first_name + ' ' + userData.last_name
          let payload = {
            userId: res.data.company,
            user_name: fullName,
          }
          context.commit('SET_USER', payload)

          localStorage.setItem('user_name', fullName)
          localStorage.setItem('userId', res.data.company)
          return true
        }
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
  tryLogin(context) {
    const token = localStorage.getItem('access_token')
    const refresh_token = localStorage.getItem('refresh_token')
    const user_name = localStorage.getItem('user_name')
    const userId = localStorage.getItem('userId')

    if (token != null) {
      context.commit('SET_TOKEN', {
        access_token: token,
        refresh_token: refresh_token,
      })

      context.commit('SET_USER', {
        user_name: user_name,
        userId: userId,
      })
    } else {
      router.push('/login')
    }
  },
  logout(context) {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user_name')
    localStorage.removeItem('userId')

    context.commit('SET_TOKEN', {
      token: null,
      refresh_token: null,
    })
    context.commit('SET_USER', {
      user_name: null,
      userId: null,
    })
  },

  autoLogout(context) {
    context.dispatch('logout')
  },

  newToken(context) {
    return axiosFactory()
      .default.post('users/token/refresh/', {
        refresh: context.getters.refreshToken,
      })
      .then((res) => {
        context.commit('SET_TOKEN', {
          access_token: res.data.access,
          refresh_token: context.getters.refreshToken,
        })
        localStorage.setItem('access_token', res.data.access)
        return true
      })
      .catch((er) => {
        router.push('/login')
        context.dispatch('logout')
        // Notification.error({
        //   title: "لطفا مجدد وارد سیستم شوید",
        //   duration: 4000,
        //   customClass: "error_msg",
        // });
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
